<template>
    <div class="stepsdemo-content">
        <Card>
            <template v-slot:title>
                Pod
            </template>
            <template v-slot:subtitle>
                Inserisci il Pod
            </template>
            <template v-slot:content>
                <div class="p-fluid">         
                    <div class="p-field">
                        <InputText id="pod"  v-model="pod" :class="['inputfield w-full',{'p-invalid': validationErrors.pod || validationErrors.format || validationErrors.lunghezza || validationErrors.exist && submitted}]"  />
                        <small v-show="validationErrors.pod && submitted" class="p-error">Campo richiesto.<br></small>
                        <small v-show="validationErrors.format && submitted" class="p-error">Formato non valido.<br></small>
                        <small v-show="validationErrors.lunghezza && submitted" class="p-error">Lunghezza non valida.</small>
                        <small v-show="validationErrors.exist && submitted" class="p-error">Pod già registrato.</small>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="grid justify-content-between">
                    <i></i>
                    <Button  label="" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" />
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import {ref, getCurrentInstance} from 'vue';
import Service from '@/services/ask-pratiche/pratiche-wizard'
import { useRoute } from 'vue-router';
import Card from 'primevue/card';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import { useToast } from "primevue/usetoast";



export default {
    components: {
        Card,
        InputText,
        Button,
    },
     props: {
        formData: Object
    },
    setup (props, {emit}) {
        const toast = useToast();
        const route = useRoute();
        const pod = ref('')
        const idContratto = ref(route.params.idContratto)
        const idCliente = ref(route.params.idCliente)
        const validationErrors = ref({})
        const submitted = ref(false)
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        const service = new Service(self.$eventBus)
        
       
        const nextPage = () => {

            submitted.value = true;
             if (validateForm()) {
                checkPodExist().then((exist) => {
                    if (exist) {            
                        emit('next-page', {
                            formData: {
                                idContratto: idContratto.value,
                                idCliente: idCliente.value,
                                pod: pod.value,
                            },
                            pageIndex: 0
                        });        
                    }          
                }) 
             }
        }

        const isValid = () => {
           //regex validate code pod
            return  /(IT)(\d{3})([A-Z]{1})(\d{8})/.test(pod.value);
        }

        const checkPodExist = async () => {
            
            const res = await service.checkPodExist(pod.value)

            if (!res.item.exist) {
                toast.removeAllGroups();            
            } else {
                toast.add({severity:'warn', summary:'Attenzione:', detail: 'Pod già registrato'});                   
            }
            
            //return true  // test
            return !res.item.exist         
        }

        
           
        const validateForm = () => {
     
            if (!pod.value.trim()) 
                validationErrors.value['pod'] = true;
             else 
                delete validationErrors.value['pod'];

            if (pod.value.length > 13 && pod.value.length < 15) 
               delete validationErrors.value['lunghezza'];
             else 
                 validationErrors.value['lunghezza'] = true;
        
            if (!isValid() && pod.value != '') 
                validationErrors.value['format'] = true;
             else 
                delete validationErrors.value['format'];
            
                       
            return !Object.keys(validationErrors.value).length;
        }

        return {
           pod, validationErrors, submitted, nextPage, isValid, checkPodExist
        }

    },
}
</script>

<style scoped>
#pod {
    text-transform: uppercase;
}
</style>
